<template>
  <div class="vp-flex vp-flex-col vp-justify-between vp-h-full">
    <div class="vp-flex vp-justify-center vp-relative">
      <TheFeatures class="vp-mt-14" />
    </div>
    <GetStartedCta>
      What are you waiting for? Start setting up your Store now!
      <template #action>
        <VpButtonPill
          label="Get Started"
          class="vp-flex-row-reverse vp-gap-2"
          :icon="$options.icons.ArrowRight"
          :to="{ name: 'cards-create' }"
        />
      </template>
    </GetStartedCta>
  </div>
</template>

<script>
import GetStartedCta from "components/src/get-started-cta.vue";
import TheFeatures from "./_features.vue";
import { ArrowRight } from "icons/icons.js";
export default {
  icons: {
    ArrowRight,
  },
  components: {
    TheFeatures,
    GetStartedCta,
  },
};
</script>
